import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ProjectSettingsDialog from "../ProjectSettingsDialog";

import { CogIcon } from "@heroicons/react/solid";
import Dropdown from "UI/Dropdown";

export default class ProjectSettingsDropdown extends React.Component
{
    state = {
        showSettingsDialog: false,
    }

    static propTypes = {
        project: PropTypes.object.isRequired,
    };

    render()
    {
        return <>
            <Dropdown button={Dropdown.VerticalDotsButton} origin='tl'>
                <Dropdown.Item onClick={() => this.setState({showSettingsDialog: true})}>
                    <CogIcon className='h-4 w-auto' />
                    <span>Manage Project</span>
                </Dropdown.Item>
            </Dropdown>

            <ProjectSettingsDialog
                project={this.props.project}
                open={this.state.showSettingsDialog}
                onClose={() => this.setState({showSettingsDialog: false})}
            />
        </>;

    }
}
